export const UPDATE_TEAM_MEMBER_SETTING_STATE = 'UPDATE_TEAM_MEMBER_SETTING_STATE'
export const NEW_MEMBERS_ADDED = 'NEW_MEMBERS_ADDED'
export const REPLACE_MEMBER_OBJECT_IN_TEAM_MEMBERS = 'REPLACE_MEMBER_OBJECT_IN_TEAM_MEMBERS'